import { createContext, useState, useEffect } from 'react';
export const UserContext = createContext();

export function UserProvider({ children }) {
  const [profilePicture, setProfilePicture] = useState(
    sessionStorage.getItem('profilePicture') || ''
  );
  const [userId, setUserId] = useState(
    Number(sessionStorage.getItem("userId"))
  );

  useEffect(() => {
    sessionStorage.setItem('profilePicture', profilePicture);
  }, [profilePicture]);

  return (
    <UserContext.Provider value={{profilePicture, setProfilePicture, userId, setUserId}}>
      {children}
    </UserContext.Provider>
  );
}
